export const DEPARTAMENTOS = [
  'Tecnologia da Informação',
  'Privacidade e Proteção de Dados',
  'Segurança da Informação',
  'Financeiro',
  'Jurídico',
  'Compliance',
  'Recursos Humanos',
  'Operações',
  'Comercial',
  'Outro',
] as const;
